import React from 'react';
import { useWidth } from '../width-context';
import { ImageInner } from './image-inner';
export function ImageContent(props) {
    var href = props.href, src = props.src;
    var availableWidth = useWidth();
    var width = Math.floor(availableWidth.width);
    return (React.createElement("table", { border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: { borderCollapse: 'collapse', borderSpacing: '0px' } },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { style: { width: width + "px" } }, href ? (React.createElement("a", { href: href, target: "_blank" },
                    React.createElement(ImageInner, { src: src, width: width }))) : (React.createElement(ImageInner, { src: src, width: width })))))));
}
//# sourceMappingURL=image-content.js.map